(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/co-op-play-marketplace/assets/javascripts/retailer-section-area.js') >= 0) return;  svs.modules.push('/components/tipsen/co-op-play-marketplace/assets/javascripts/retailer-section-area.js');

'use strict';

const {
  RetailerSection,
  RetailerGamePropType,
  RetailerInfoBox,
  RetailerSectionSkeleton
} = svs.components.tipsen;
const RetailerSectionArea = _ref => {
  let {
    branding,
    hasMoreData,
    icon,
    isHidden,
    isLoading,
    loadCount,
    noResult,
    retailers,
    title,
    totalCount
  } = _ref;
  if (isHidden) {
    return null;
  }
  const shiftFocus = e => {
    const btn = e.target.closest('.skip-link');
    const target = document.getElementById(btn.dataset.target);
    target === null || target === void 0 || target.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
    target === null || target === void 0 || target.focus();
  };
  return React.createElement("section", {
    className: "co-op-play-retail-section-area"
  }, React.createElement("div", {
    className: "co-op-play-retail-section-header"
  }, React.createElement("h2", {
    className: "tipsen-header f-center f-medium",
    id: "list-top",
    tabIndex: -1
  }, title, !isLoading && React.createElement("span", {
    "aria-live": "polite",
    className: "co-op-play-retail-section-header-count",
    role: "region"
  }, " (".concat(totalCount, " st.)")))), React.createElement("div", {
    className: "co-op-play-retail-sections"
  }, retailers === null || retailers === void 0 ? void 0 : retailers.map(retailer => React.createElement(RetailerSection, {
    branding: branding,
    key: "global-".concat(retailer.id),
    retailer: retailer
  })), isLoading && [...Array(loadCount).keys()].map(key => React.createElement(RetailerSectionSkeleton, {
    key: key
  })), !isLoading && !(retailers !== null && retailers !== void 0 && retailers.length) && React.createElement(RetailerInfoBox, {
    icon: icon,
    text: noResult
  })), !hasMoreData && React.createElement("button", {
    className: "skip-end skip-link",
    "data-target": "list-top",
    id: "end-retailers",
    onClick: shiftFocus,
    type: "button"
  }, "Slut p\xE5 butiker. Hoppa till b\xF6rjan av listan."));
};
RetailerSectionArea.defaultProps = {
  branding: 'sport',
  icon: 'rtp',
  isHidden: false,
  isLoading: false
};
setGlobal('svs.components.tipsen.RetailerSectionArea', RetailerSectionArea);

 })(window);